import type { ContextTokenData } from '../types';

export class ContextTokenCache {
    private static instance: ContextTokenCache;
    private contextTokenCacheMap: Map<string, ContextTokenData>;

    static getInstance() {
        if (!ContextTokenCache.instance) {
            ContextTokenCache.instance = new ContextTokenCache();
        }
        return ContextTokenCache.instance;
    }

    constructor() {
        this.contextTokenCacheMap = new Map<string, ContextTokenData>();
    }

    setValue(key: string, value: ContextTokenData): void {
        this.contextTokenCacheMap.set(key, value);
    }

    getValue(key: string): ContextTokenData | undefined {
        return this.contextTokenCacheMap.get(key);
    }

    del(key: string): void {
        this.contextTokenCacheMap.delete(key);
    }
}
